import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CompanyManagerRegistrationStatus } from '@review-company-manager/models/company-manager-registration-status';

export const reviewCompanyManagerResultGuard: CanActivateFn = () => {
  const router = inject(Router);
  return ['SUCCESS', 'MANAGER_NOT_REGISTERED'].includes(
    router.currentNavigation()?.extras.state?.result as CompanyManagerRegistrationStatus,
  )
    ? true
    : router.parseUrl('');
};
